import { normalizeUrl, ProfileLinks } from './ProfileLinks';
import './BusinessOrganizerCard.css';

const SERVICE_LABELS = { tours: 'Guided Tours', lessons: 'Coaching & Lessons' };

// Business logo + name shown under the organizer's own profile card on tour /
// route detail pages — the services the business offers, and clickable
// email/phone/social/website icons (same row style as the personal profile
// above it). The header row opens the business website in a new tab.
export function BusinessOrganizerCard({ business }) {
  if (!business?.name) return null;
  const href = business.website ? normalizeUrl(business.website) : null;
  const services = Array.isArray(business.services) ? business.services : [];

  const HeaderTag = href ? 'a' : 'div';
  const headerProps = href
    ? { href, target: '_blank', rel: 'noopener noreferrer', title: `Visit ${business.name}` }
    : {};

  return (
    <div className="boc">
      <HeaderTag className={`boc__header${href ? ' boc__header--link' : ''}`} {...headerProps}>
        {business.logoUrl
          ? <img className="boc__logo" src={business.logoUrl} alt="" />
          : <span className="boc__logo boc__logo--initial">{business.name[0]?.toUpperCase()}</span>}
        <span className="boc__info">
          <span className="boc__label">Business</span>
          <span className="boc__name">{business.name}</span>
        </span>
        {href && (
          <svg className="boc__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
        )}
      </HeaderTag>

      {services.length > 0 && (
        <div className="boc__services">
          {services.map(s => (
            <span className="boc__service" key={s}>{SERVICE_LABELS[s] || s}</span>
          ))}
        </div>
      )}

      <ProfileLinks
        profile={{ isBusiness: true, businessEmail: business.email, businessPhone: business.phone, links: business.links }}
        hideBusiness
      />
    </div>
  );
}
